import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  compareTo3ankvs086tmwq as compareTo,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  numberToLong1a4cndvg6c52s as numberToLong,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  Comparable198qfk8pnblz0 as Comparable,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  hashCodeq5arwsb9dgti as hashCode,
  Unit_instanceat14thlj150z as Unit_instance,
  Iterable1y3qizuf89iou as Iterable,
  contentEquals5p44wfjhu6ta as contentEquals,
  contentHashCodem24x0wy7gjt7 as contentHashCode,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.t26_1 = _Int53___init__impl__iowqng(0.0);
    this.u26_1 = _Int53___init__impl__iowqng(4.503599627370495E15);
    this.v26_1 = _Int53___init__impl__iowqng(-4.503599627370495E15);
    this.w26_1 = 4.294967295E9;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = new Float64Array(64);
    while (tmp_0 < 64) {
      var tmp_2 = tmp_0;
      // Inline function 'kotlin.math.pow' call
      tmp_1[tmp_2] = Math.pow(2.0, tmp_2);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.x26_1 = tmp_1;
  }
}
class Int53 {
  constructor(value) {
    Companion_getInstance();
    this.y26_1 = value;
  }
  z26(other) {
    return Int53__compareTo_impl_jyh2e_0(this.y26_1, other);
  }
  d(other) {
    return Int53__compareTo_impl_jyh2e_1(this, other);
  }
  toString() {
    return Int53__toString_impl_j0waj0(this.y26_1);
  }
  hashCode() {
    return Int53__hashCode_impl_u91un9(this.y26_1);
  }
  equals(other) {
    return Int53__equals_impl_mpun7j(this.y26_1, other);
  }
}
class Companion_0 {}
class Int53Array$iterator$1 {
  constructor(this$0) {
    this.c27_1 = this$0;
    this.b27_1 = 0;
  }
  c1() {
    return this.b27_1 < _Int53Array___get_raw__impl__6kxpfy(this.c27_1).length;
  }
  d27() {
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.number.Int53Array.get' call
    var this_0 = this.c27_1;
    var index = this.b27_1;
    var tmp$ret$0 = _Int53___init__impl__iowqng(_Int53Array___get_raw__impl__6kxpfy(this_0)[index]);
    var this_1 = new Int53(tmp$ret$0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.number.<no name provided>.next.<anonymous>' call
    this_1.y26_1;
    this.b27_1 = this.b27_1 + 1 | 0;
    return this_1.y26_1;
  }
  d1() {
    return new Int53(this.d27());
  }
}
class Int53Array {
  constructor(raw) {
    this.a27_1 = raw;
  }
  b1() {
    return Int53Array__iterator_impl_29xi4z(this.a27_1);
  }
  toString() {
    return Int53Array__toString_impl_nai52j(this.a27_1);
  }
  hashCode() {
    return Int53Array__hashCode_impl_pzg03q(this.a27_1);
  }
  equals(other) {
    return Int53Array__equals_impl_bpjee6(this.a27_1, other);
  }
}
//endregion
function _Int53___init__impl__iowqng(value) {
  return value;
}
function _Int53___get_value__impl__ww0yo($this) {
  return $this;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function Int53__insertNoClear_impl_aaadnr($this, value, offset, count) {
  var tmp = _Int53___get_value__impl__ww0yo($this);
  var tmp_0 = value & mask(count);
  // Inline function 'korlibs.number.Companion.pot' call
  var tmp$ret$0 = Companion_getInstance().x26_1[offset & 63];
  return _Int53___init__impl__iowqng(tmp + tmp_0 * tmp$ret$0);
}
function Int53__insertNoClear_impl_aaadnr_0($this, value, offset) {
  return Int53__insertNoClear_impl_aaadnr($this, value ? 1 : 0, offset, 1);
}
function Int53__extract_impl_ikc3ev($this, offset, bits) {
  // Inline function 'kotlin.math.floor' call
  var tmp = _Int53___get_value__impl__ww0yo($this);
  // Inline function 'korlibs.number.Companion.pot' call
  var x = tmp / Companion_getInstance().x26_1[offset & 63];
  var tmp_0 = Math.floor(x);
  // Inline function 'korlibs.number.Companion.pot' call
  var tmp$ret$2 = Companion_getInstance().x26_1[bits & 63];
  return numberToInt(tmp_0 % tmp$ret$2);
}
function Int53__extract_impl_ikc3ev_0($this, offset) {
  return !(Int53__extract_impl_ikc3ev($this, offset, 1) === 0);
}
function Int53__extractSigned_impl_v59qt9($this, offset, bits) {
  var shift = 32 - bits | 0;
  return Int53__extract_impl_ikc3ev($this, offset, bits) << shift >> shift;
}
function _Int53___get_double__impl__onpr98($this) {
  return _Int53___get_value__impl__ww0yo($this);
}
function Int53__toDouble_impl_ksu7f0($this) {
  return _Int53___get_double__impl__onpr98($this);
}
function Int53__compareTo_impl_jyh2e($this, other) {
  return compareTo(_Int53___get_value__impl__ww0yo($this), other);
}
function Int53__compareTo_impl_jyh2e_0($this, other) {
  return Int53__compareTo_impl_jyh2e($this, Int53__toDouble_impl_ksu7f0(other));
}
function Int53__compareTo_impl_jyh2e_1($this, other) {
  return Int53__compareTo_impl_jyh2e_0($this.y26_1, other instanceof Int53 ? other.y26_1 : THROW_CCE());
}
function Int53__toString_impl_j0waj0($this) {
  return removeSuffix(numberToLong(_Int53___get_value__impl__ww0yo($this)).toString(), '.0');
}
function Int53__hashCode_impl_u91un9($this) {
  return getNumberHashCode($this);
}
function Int53__equals_impl_mpun7j($this, other) {
  if (!(other instanceof Int53))
    return false;
  var tmp0_other_with_cast = other instanceof Int53 ? other.y26_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _Int53Array___init__impl__gn3wej(raw) {
  return raw;
}
function _Int53Array___get_raw__impl__6kxpfy($this) {
  return $this;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function Int53Array__iterator_impl_29xi4z($this) {
  return new Int53Array$iterator$1($this);
}
function Int53Array__toString_impl_nai52j($this) {
  // Inline function 'korlibs.number.Int53Array.size' call
  return 'IntArray64(' + _Int53Array___get_raw__impl__6kxpfy($this).length + ')';
}
function Int53Array__hashCode_impl_pzg03q($this) {
  return hashCode($this);
}
function Int53Array__equals_impl_bpjee6($this, other) {
  if (!(other instanceof Int53Array))
    return false;
  var tmp0_other_with_cast = other instanceof Int53Array ? other.a27_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function contentEquals_0(_this__u8e3s4, other) {
  var tmp;
  var tmp_0 = _this__u8e3s4;
  if ((tmp_0 == null ? null : new Int53Array(tmp_0)) == null) {
    tmp = null;
  } else {
    tmp = _Int53Array___get_raw__impl__6kxpfy(_this__u8e3s4);
  }
  var tmp_1 = tmp;
  var tmp_2;
  var tmp_3 = other;
  if ((tmp_3 == null ? null : new Int53Array(tmp_3)) == null) {
    tmp_2 = null;
  } else {
    tmp_2 = _Int53Array___get_raw__impl__6kxpfy(other);
  }
  return contentEquals(tmp_1, tmp_2);
}
function contentHashCode_0(_this__u8e3s4) {
  var tmp;
  var tmp_0 = _this__u8e3s4;
  if ((tmp_0 == null ? null : new Int53Array(tmp_0)) == null) {
    tmp = null;
  } else {
    tmp = _Int53Array___get_raw__impl__6kxpfy(_this__u8e3s4);
  }
  return contentHashCode(tmp);
}
function mask(_this__u8e3s4) {
  return (1 << _this__u8e3s4) - 1 | 0;
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(Int53, 'Int53', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(Int53Array$iterator$1);
initMetadataForClass(Int53Array, 'Int53Array', VOID, VOID, [Iterable]);
//endregion
//region block: init
Companion_instance_0 = new Companion_0();
//endregion
//region block: exports
export {
  _Int53___init__impl__iowqng as _Int53___init__impl__iowqng217zysgv5n7hi,
  Int53__extractSigned_impl_v59qt9 as Int53__extractSigned_impl_v59qt9d1lcr64lbdej,
  Int53__extract_impl_ikc3ev_0 as Int53__extract_impl_ikc3evy2evy7i0ffff,
  Int53__extract_impl_ikc3ev as Int53__extract_impl_ikc3evljmx5jz12lam,
  Int53__insertNoClear_impl_aaadnr_0 as Int53__insertNoClear_impl_aaadnr2g6a491qumb9d,
  Int53__insertNoClear_impl_aaadnr as Int53__insertNoClear_impl_aaadnr3l30mzmlgy6ww,
  Int53__toString_impl_j0waj0 as Int53__toString_impl_j0waj0366nerregb2yc,
  _Int53___get_value__impl__ww0yo as _Int53___get_value__impl__ww0yo3sycx74wn0sq7,
  _Int53Array___init__impl__gn3wej as _Int53Array___init__impl__gn3wej1wobb2eteq00p,
  Int53Array__iterator_impl_29xi4z as Int53Array__iterator_impl_29xi4z2bmi7lcwkuzdi,
  _Int53Array___get_raw__impl__6kxpfy as _Int53Array___get_raw__impl__6kxpfy162bfaxaiidle,
  Companion_getInstance as Companion_getInstance2fdy01ctwk4tu,
  Companion_instance_0 as Companion_instance1818l4yj5cjpb,
  Int53Array as Int53Array2e5awid9sqa75,
  Int53 as Int532aaztjxx675u5,
  contentEquals_0 as contentEquals3iwymudvpxgk,
  contentHashCode_0 as contentHashCodeszilr1s8tm6t,
};
//endregion
